import simpleParallax from "simple-parallax-js";
import gsap from "gsap";
import scrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(scrollTrigger);

const galleryItems = document.querySelectorAll(".gallery-item");

gsap.from(galleryItems, {
	duration: 1.4,
	ease: "power3.out",
	y: "200px",
	opacity: "0",
	delay: 0.6,
});

new simpleParallax(document.querySelectorAll(".gallery-item img"), {
	delay: 0.8,
	scale: 1.3,
});
